import { useGameStore } from '@/state/gameStore';
import { useAuthStore } from '@/state/authStore';
import { audioService } from '@/services/audioService';
import { clearRoot, el, mount } from './dom';
import { showRecords } from './RecordsOverlay';
import { showSettings } from './SettingsOverlay';

export function showMenu(): void {
  clearRoot();
  const auth = useAuthStore.getState();
  const game = useGameStore.getState();

  const muted = audioService.isMuted();
  const hasNickname = auth.displayName && auth.displayName.trim().length > 0;
  const hasBest = auth.bestScore > 0;

  const wrap = el(
    'div',
    {
      class: 'fixed inset-0 flex flex-col items-center justify-center px-6 py-10 fade-in'
    },
    [
      el('div', { class: 'flex flex-col items-center gap-2 mb-8' }, [
        el('div', { class: 'text-accent text-sm tracking-[0.4em] uppercase' }, ['Math']),
        el('h1', { class: 'font-display text-6xl text-white drop-shadow-[0_4px_24px_rgba(34,211,238,0.4)]' }, [
          'NINJA'
        ]),
        el('p', { class: 'text-white/60 text-center mt-3 max-w-xs text-sm' }, [
          'Resuelve la operación y toca el cuadro con la cantidad correcta de puntos.'
        ])
      ]),
      hasBest ? bestPanel(auth.displayName, auth.bestScore, auth.bestLevel, auth.totalGames) : empty(),
      el('div', { class: 'flex flex-col gap-3 w-full max-w-xs mt-6' }, [
        buttonPrimary('▶ Jugar', () => {
          audioService.init();
          game.startGame();
        }),
        buttonSecondary('🎓 Tutorial', () => {
          audioService.init();
          game.startTutorial();
        }),
        buttonSecondary('🏆 Récords', () => showRecords()),
        buttonGhost('⚙ Ajustes', () => showSettings())
      ]),
      el('div', { class: 'absolute bottom-6 left-0 right-0 flex flex-col items-center gap-1' }, [
        el('div', { class: 'text-white/40 text-xs' }, [
          hasNickname ? `Jugador: ${auth.displayName}` : 'Anónimo · pon tu nickname en Ajustes'
        ]),
        el('div', { class: 'text-white/30 text-[10px] tracking-widest uppercase' }, [
          muted ? 'Sonido apagado' : 'Sonido activo'
        ]),
        el('div', { class: 'text-white/30 text-[10px] tracking-widest uppercase' }, [
          'v1.0'
        ]),
        el('div', { class: 'text-white/50 text-[11px] mt-2 tracking-wide' }, [
          'Power by ',
          (() => {
            const a = el(
              'a',
              {
                href: 'https://jonnatangomez.elingedice.com/',
                target: '_blank',
                rel: 'noopener noreferrer',
                class: 'text-accent font-semibold hover:underline'
              },
              ['El Inge Dice']
            );
            return a;
          })()
        ])
      ])
    ]
  );
  mount(wrap);
}

function bestPanel(name: string, score: number, level: number, games: number): HTMLElement {
  return el(
    'div',
    { class: 'panel w-full max-w-xs px-5 py-4 flex flex-col items-center gap-1' },
    [
      el('div', { class: 'text-white/50 text-[11px] tracking-[0.25em] uppercase' }, [
        '⭐ Tu mejor récord'
      ]),
      el('div', { class: 'font-display text-4xl text-accent' }, [
        score.toLocaleString('es-MX')
      ]),
      el('div', { class: 'text-white/60 text-xs' }, [
        `Nivel ${level + 1} · ${games} ${games === 1 ? 'partida' : 'partidas'}` +
          (name ? ` · ${name}` : '')
      ])
    ]
  );
}

function empty(): HTMLElement {
  return el('div', { class: 'h-0' }, []);
}

function buttonPrimary(label: string, onClick: () => void): HTMLElement {
  const b = el('button', { class: 'btn-primary w-full' }, [label]);
  b.addEventListener('click', onClick);
  return b;
}
function buttonSecondary(label: string, onClick: () => void): HTMLElement {
  const b = el('button', { class: 'btn-secondary w-full' }, [label]);
  b.addEventListener('click', onClick);
  return b;
}
function buttonGhost(label: string, onClick: () => void): HTMLElement {
  const b = el('button', { class: 'btn-ghost w-full' }, [label]);
  b.addEventListener('click', onClick);
  return b;
}
